/* RUWI Abschreibungsrechner - erzeugt von abschreibungsrechner/build.ps1 am 14.09.2026 14:52.
   NICHT VON HAND AENDERN - Quelle ist abschreibungsrechner/index.html.
   Erwartet window.RUWI_AB mit daten, gruppen, stand, zins, stundensatz. */
(function () {
  'use strict';

  var root = document.querySelector('.ruwi-ab');
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

  /* ---------------------------------------------------------------------
     Rechtsstand und Landesregeln
     DE ist belegt (siehe PROJEKTBUCH). AT, CH, NL bewusst flach.
     --------------------------------------------------------------------- */
  /* Aus der Section einstellbar. Die Werte hier sind der Rückfall für die Vorschau. */
  var CFG0 = window.RUWI_AB || {};
  var STAND = CFG0.stand || '13. September 2026';

  var LAND = {
    DE: {
      name: 'Deutschland', waehrung: '€', locale: 'de-DE',
      mwst: 0.19, gwg: 800, gwgText: '800 € netto', tief: true,
      nutzungsdauer: 14, degFaktor: 3, degKappe: 0.30,
      sonderAfa: 0.40, iab: 0.50, gewinngrenze: 200000, begJahre: 5,
      satzHint: 'Grenzsteuersatz oder Körperschaft- plus Gewerbesteuer. Im Zweifel 30 % als Hausnummer.'
    },
    AT: {
      name: 'Österreich', waehrung: '€', tief: false,
      mwst: 0.20,
      satzHint: 'Einkommen- oder Körperschaftsteuersatz. Im Zweifel 30 % als Hausnummer.',
      hinweis: 'Für Österreich rechnen wir nur die Vorsteuer und die Gesamtwirkung über die ' +
               'Nutzungsdauer. Geringwertige Wirtschaftsgüter, Nutzungsdauer und ' +
               'Investitionsfreibetrag richten sich nach österreichischem Recht – das bilden ' +
               'wir hier nicht ab.'
    },
    CH: {
      name: 'Schweiz', waehrung: '€', tief: false,
      mwst: 0.081,
      satzHint: 'Gewinnsteuersatz deines Kantons – er liegt meist deutlich unter 30 %.',
      hinweis: 'Die Preise sind Euro-Listenpreise ab Werk. Bei Lieferung in die Schweiz zahlst du ' +
               'keine deutsche Mehrwertsteuer, sondern Einfuhrsteuer beim Zoll; die 8,1 % sind hier ' +
               'als Näherung angesetzt. Abschreibungssätze und Aktivierungsgrenzen sind kantonal ' +
               'geregelt – das bilden wir hier nicht ab.'
    },
    NL: {
      name: 'Niederlande', waehrung: '€', tief: false,
      mwst: 0.21,
      satzHint: 'Inkomsten- oder Vennootschapsbelasting. Im Zweifel 30 % als Hausnummer.',
      hinweis: 'Für die Niederlande rechnen wir nur die Vorsteuer und die Gesamtwirkung über die ' +
               'Nutzungsdauer. Afschrijving, drempelbedragen und die Kleinschaligheidsinvesterings' +
               'aftrek bilden wir hier nicht ab.'
    }
  };

  var MONATE = ['Januar','Februar','März','April','Mai','Juni',
                'Juli','August','September','Oktober','November','Dezember'];

  /* Nicht `||`: 0 % Kapitalkosten sind eine gültige Einstellung und dürfen
     nicht still auf 6 % zurückfallen. */
  var ZINS = (typeof CFG0.zins === 'number') ? CFG0.zins : 0.06;

  /* ---------------------------------------------------------------------
     Zustand
     --------------------------------------------------------------------- */
  var S = {
    land: 'DE',
    modus: 'betrieb',
    satz: 30,
    monat: new Date().getMonth() + 1,
    weg: 'hebel',
    gewinn: null,        /* null = nicht beantwortet, 'klein' oder 'gross'.
                            Ungefragt anzunehmen, jemand liege unter der Grenze,
                            verschenkt bei einem größeren Betrieb eine falsche Zahl. */
    stueck: 1,
    titelUrl: '',        /* Titel aus der Adresse – überlebt leseNetto() */
    geraet: 0,           /* Hauptgerät, netto */
    zubehoer: 0,         /* Ausstattung, netto, konservativ mit dem Gerät aktiviert */
    netto: 0,            /* Summe aus beidem */
    titel: '',
    variante: null,      /* Shopify-Varianten-ID für den Warenkorb */
    handle: ''
  };

  function gross() { return S.gewinn === 'gross'; }
  function gewinnOffen() { return S.gewinn === null; }

  /* Welcher Weg tatsächlich gerechnet wird. S.weg ist der Wunsch des Nutzers,
     dieser hier ist das, was die Gewinnfrage davon übrig lässt. */
  function wegAktiv() {
    if (gewinnOffen()) { return 'linear'; }
    if (gross() && S.weg === 'iab') { return 'hebel'; }
    return S.weg;
  }
  function wegeOffen() {
    if (gewinnOffen()) { return ['linear']; }
    return gross() ? ['linear', 'hebel'] : ['linear', 'hebel', 'iab'];
  }

  /* Ab Oktober rückt der Dezember-Hebel nach oben.
     `?saison=1` erzwingt das zum Ansehen, solange es noch nicht Oktober ist. */
  var SAISON = ((new Date().getMonth() + 1) >= 10) || /[?&]saison=1/.test(location.search);

  /* ---------------------------------------------------------------------
     Formatierung
     --------------------------------------------------------------------- */
  function fmt(n, stellen) {
    var d = (stellen === undefined) ? 2 : stellen;
    return n.toLocaleString('de-DE', { minimumFractionDigits: d, maximumFractionDigits: d });
  }
  function geld(n, stellen) { return fmt(n, stellen) + ' ' + LAND[S.land].waehrung; }
  function geldR(n) { return fmt(Math.round(n), 0) + ' ' + LAND[S.land].waehrung; }
  function proz(n) { return fmt(n, n < 10 ? 1 : 0).replace(/,0$/, '') + ' %'; }

  /* ---------------------------------------------------------------------
     Rechenkern
     Gibt je Weg ein Feld mit den Abschreibungsbeträgen pro Jahr zurück.
     vorjahr = Betrag, der schon im Jahr VOR dem Kauf den Gewinn mindert (IAB).
     --------------------------------------------------------------------- */
  function planLinear(netto, nd, monat) {
    var monate = 13 - monat;
    var jahresrate = netto / nd;
    var reihe = [jahresrate * monate / 12];
    for (var i = 1; i < nd; i++) { reihe.push(jahresrate); }
    if (monate < 12) { reihe.push(jahresrate * (12 - monate) / 12); }
    return { vorjahr: 0, reihe: reihe };
  }

  function planHebel(netto, d, monat, bemessung, mitSonder) {
    /* bemessung = Abschreibungsgrundlage (bei IAB die gekürzten Anschaffungskosten)
       mitSonder = false, wenn der Gewinn über 200.000 € liegt. Die degressive AfA
       hängt nicht an dieser Grenze, nur § 7g. */
    var basis = (bemessung === undefined) ? netto : bemessung;
    var monate = 13 - monat;
    var degSatz = Math.min(d.degFaktor / d.nutzungsdauer, d.degKappe);

    /* Sonderabschreibung § 7g Abs. 5: Jahresbetrag, NICHT zeitanteilig. */
    var sonder = (mitSonder === false) ? 0 : basis * d.sonderAfa;
    var deg1 = basis * degSatz * monate / 12;

    var reihe = [sonder + deg1];
    var buchwert = basis - reihe[0];

    if (sonder > 0) {
      /* Mit Sonderabschreibung: fünf Jahre degressiv, danach der Restbuchwert
         gleichmäßig auf die Restnutzungsdauer – § 7a Abs. 9 EStG. */
      for (var i = 1; i < d.begJahre; i++) {
        var a = buchwert * degSatz;
        reihe.push(a);
        buchwert -= a;
      }
      var restjahre = Math.max(1, d.nutzungsdauer - d.begJahre);
      for (var k = 0; k < restjahre; k++) { reihe.push(buchwert / restjahre); }
    } else {
      /* Ohne Sonderabschreibung greift § 7a Abs. 9 nicht. Dann läuft die
         degressive AfA weiter, bis die lineare auf die Restnutzungsdauer mehr
         bringt – der übliche Wechsel nach § 7 Abs. 3 EStG. */
      for (var j = 1; j < d.nutzungsdauer; j++) {
        var restND = d.nutzungsdauer - j;
        var degBetrag = buchwert * degSatz;
        var linBetrag = buchwert / restND;
        if (linBetrag >= degBetrag) {
          for (var n = 0; n < restND; n++) { reihe.push(buchwert / restND); }
          buchwert = 0;
          break;
        }
        reihe.push(degBetrag);
        buchwert -= degBetrag;
      }
      if (buchwert > 0.005) { reihe.push(buchwert); }
    }

    return { vorjahr: 0, reihe: reihe };
  }

  function planIab(netto, d, monat) {
    /* Vorjahr: IAB mindert den Gewinn um 50 % der geplanten Anschaffungskosten.
       Kaufjahr: Hinzurechnung (+50 %) und Herabsetzung (-50 %) heben sich auf,
       die AfA-Bemessungsgrundlage sinkt auf 50 %. */
    var p = planHebel(netto, d, monat, netto * (1 - d.iab), true);
    p.vorjahr = netto * d.iab;
    return p;
  }

  function planGwg(netto) {
    /* § 6 Abs. 2 EStG: voller Abzug im Kaufjahr, ohne Monatsanteil. */
    return { vorjahr: 0, reihe: [netto] };
  }

  /* annahme überschreibt die Gewinnfrage für eine einzelne Rechnung. Die
     Dezember-Karte braucht das: Sie erklärt § 7g und muss deshalb auch dann mit
     § 7g rechnen, wenn der Nutzer die Frage noch nicht beantwortet hat – sonst
     stünden unter der Überschrift „Die Sonderabschreibung wird nicht gezwölftelt“
     rein lineare Zahlen, die genau das Gegenteil zeigen. */
  function rechne(weg, annahme) {
    var gAnn = (annahme === undefined) ? S.gewinn : annahme;
    var annOffen = (gAnn === null || gAnn === undefined);
    var annGross = (gAnn === 'gross');
    var d = LAND[S.land];
    var netto = S.netto;
    var brutto = netto * (1 + d.mwst);
    var vorsteuer = (S.modus === 'betrieb') ? brutto - netto : 0;

    var plan;
    /* Die 800-€-Grenze ist eine deutsche Regel (§ 6 Abs. 2 EStG). Für die anderen
       Länder behaupten wir keine Schwelle, weil wir keine belegte haben. */
    var istGwg = d.tief && netto > 0 && netto <= d.gwg;

    if (S.modus === 'privat') {
      plan = { vorjahr: 0, reihe: [] };
    } else if (!d.tief) {
      /* AT, CH, NL: nur Vorsteuer und Gesamtwirkung. Keinen Jahresverlauf erfinden.
         gesamtabzug gilt in jedem System: über die Nutzungsdauer werden die vollen
         Anschaffungskosten abgesetzt – nur die Verteilung ist national verschieden. */
      plan = { vorjahr: 0, reihe: [], gesamtabzug: netto };
    } else if (istGwg) {
      plan = planGwg(netto);
    } else if (weg === 'linear' || annOffen) {
      /* Solange die Gewinnfrage offen ist, rechnen wir den Weg, der immer gilt.
         Alles andere wäre eine Annahme über den Betrieb, die wir nicht treffen. */
      plan = planLinear(netto, d.nutzungsdauer, S.monat);
    } else if (weg === 'iab' && !annGross) {
      plan = planIab(netto, d, S.monat);
    } else {
      plan = planHebel(netto, d, S.monat, undefined, !annGross);
    }

    var f = S.satz / 100;
    var erspVorjahr = plan.vorjahr * f;
    var ersparnisse = plan.reihe.map(function (a) { return a * f; });
    var summe = ersparnisse.reduce(function (a, b) { return a + b; }, 0) + erspVorjahr;
    if (plan.gesamtabzug !== undefined) { summe = plan.gesamtabzug * f; }

    /* Barwert der Steuerersparnis: Vorjahr ein Jahr früher, dann Jahr 1..n */
    var barwert = erspVorjahr;
    ersparnisse.forEach(function (e, i) { barwert += e / Math.pow(1 + ZINS, i + 1); });

    return {
      netto: netto, brutto: brutto, vorsteuer: vorsteuer,
      istGwg: istGwg, plan: plan,
      erspVorjahr: erspVorjahr, ersparnisse: ersparnisse,
      erspJahr1: ersparnisse.length ? ersparnisse[0] : 0,
      erspGesamt: summe,
      abschrJahr1: plan.reihe.length ? plan.reihe[0] : 0,
      barwert: barwert,
      /* Was bis zum Ende des Kaufjahrs unterm Strich abfließt. Der Investitionsabzugsbetrag
         wirkt schon im Vorjahr – ohne ihn sähe der stärkere Weg hier schwächer aus. */
      kaufjahr: brutto - vorsteuer - (ersparnisse.length ? ersparnisse[0] : 0) - erspVorjahr,
      /* Was über die ganze Nutzungsdauer übrig bleibt */
      gesamt: brutto - vorsteuer - summe
    };
  }

  /* ---------------------------------------------------------------------
     Produktliste
     --------------------------------------------------------------------- */
  /* Preise und Varianten-IDs kommen aus derselben erzeugten Datei wie beim
     Werkstattberater. Die zweite Datei liefert nur die Einordnung: welcher
     Artikel in welche Gruppe gehoert und wie er heissen soll.
     Shopify liefert Bruttopreise (cart.taxes_included), daher der Teiler. */
  var CFG = window.RUWI_AB || {};
  /* Ob Shopify brutto speichert, sagt die Section über cart.taxes_included –
     wir raten es nicht mehr. */
  var SHOP_MWST = (CFG.inkl === false) ? 1 : 1.19;
  var PRODUKTE = [];

  function ladeProdukte(fertig) {
    var holen = function (u) {
      return fetch(u).then(function (res) {
        if (!res.ok) { throw new Error(u); }
        return res.json();
      });
    };
    Promise.all([
      holen(CFG.daten || 'werkstattberater-daten.json'),
      holen(CFG.gruppen || 'gruppen.json')
    ]).then(function (a) {
      var daten = (a[0] && a[0].data) || {};
      var tax = a[1] || { g: [], p: {} };
      Object.keys(daten).forEach(function (handle) {
        (daten[handle].v || []).forEach(function (v) {
          var e = tax.p[v.sku];
          if (!e || !v.p || v.p <= 0) { return; }
          var netto = Math.round(v.p / SHOP_MWST) / 100;
          if (netto < 5) { return; }
          PRODUKTE.push({
            g: tax.g[e[0]], n: e[1], reihe: e[2],
            a: v.sku, p: netto, i: v.id, h: handle, da: v.a !== false
          });
        });
      });
      PRODUKTE.sort(function (x, y) { return x.reihe - y.reihe; });
      fertig();
    }).catch(function () {
      /* Ohne Produktliste bleibt der Rechner benutzbar – nur eben mit eigenem Betrag. */
      var sel = $('#abProd');
      sel.innerHTML = '<option value="eigen">Eigener Betrag …</option>';
      sel.value = 'eigen';
      $('#abEigenFeld').hidden = false;
      fertig();
    });
  }

  function baueProdukte() {
    var sel = $('#abProd');
    var gruppen = {};
    var reihenfolge = [];
    PRODUKTE.forEach(function (p) {
      if (!gruppen[p.g]) { gruppen[p.g] = []; reihenfolge.push(p.g); }
      gruppen[p.g].push(p);
    });
    reihenfolge.forEach(function (g) {
      var og = document.createElement('optgroup');
      og.label = g;
      gruppen[g].forEach(function (p) {
        var o = document.createElement('option');
        o.value = String(p.p);
        o.textContent = p.n + ' — ' + fmt(p.p, 2) + ' € netto' +
                        (p.da === false ? ' (derzeit nicht lieferbar)' : '');
        o.dataset.name = p.n;
        if (p.i) { o.dataset.variante = p.i; }
        if (p.h) { o.dataset.handle = p.h; }
        if (p.da === false) { o.dataset.aus = '1'; }
        og.appendChild(o);
      });
      sel.appendChild(og);
    });
    var eigen = document.createElement('option');
    eigen.value = 'eigen';
    eigen.textContent = 'Eigener Betrag …';
    sel.appendChild(eigen);

    /* Vorauswahl: Hubtisch Premium, sonst der erste Eintrag */
    var treffer = Array.prototype.filter.call(sel.options, function (o) {
      return o.dataset.name === 'Hubtisch Premium';
    })[0];
    if (treffer) { sel.value = treffer.value; }
  }

  function leseNetto() {
    var sel = $('#abProd');
    var o = sel.options[sel.selectedIndex];
    if (sel.value === 'eigen') {
      S.titel = 'Eigener Betrag';
      S.variante = null;
      S.handle = '';
      S.geraet = parseFloat($('#abEigen').value) || 0;
    } else {
      S.titel = o ? (o.dataset.name || '') : '';
      S.variante = (o && o.dataset.variante) ? o.dataset.variante : null;
      S.handle = (o && o.dataset.handle) ? o.dataset.handle : '';
      S.lieferbar = !(o && o.dataset.aus === '1');
      S.geraet = parseFloat(sel.value) || 0;
    }
    /* Ein Titel aus der Adresse (vom Berater oder von der Produktseite) darf hier
       nicht verloren gehen – sonst steht auf dem Druckblatt „Eigener Betrag“. */
    if (S.titelUrl) { S.titel = S.titelUrl; }

    /* Der Grundtitel wandert in die Adresse, die Stückzahl separat. Sonst stünde
       nach einmal Neuladen „4 × 4 × Hubtisch Premium“ da. */
    S.titelBasis = S.titel;
    S.stueck = Math.max(1, Math.min(99, parseInt($('#abStueck').value, 10) || 1));
    if (S.stueck > 1) { S.titel = S.stueck + ' × ' + S.titelBasis; }

    S.zubehoer = $('#abZubFeld').hidden ? 0 : (parseFloat($('#abZub').value) || 0);
    return S.geraet * S.stueck + S.zubehoer;
  }

  /* ---------------------------------------------------------------------
     Anzeige
     --------------------------------------------------------------------- */
  function zeichneErgebnis(r) {
    var d = LAND[S.land];
    var zeilen = [];

    if (S.modus === 'privat') {
      $('#abHeroL').textContent = 'Dein Preis – einmal';
      $('#abHero').textContent = geldR(r.brutto);
      $('#abHeroS').textContent = 'Als Privatkäufer zahlst du brutto. Kein Vorsteuerabzug, keine Abschreibung.';
      zeilen.push(['Nettopreis', geld(r.netto), true]);
      zeilen.push(['Mehrwertsteuer ' + proz(d.mwst * 100), geld(r.brutto - r.netto), true]);
      zeilen.push(['Dein Preis', geld(r.brutto), false]);
      $('#abMarke').textContent = 'Privatkauf';
    } else {
      if (d.tief) {
        zeilen.push(['Bruttopreis beim Kauf', geld(r.brutto), false]);
        zeilen.push(['Vorsteuer – zurück mit der nächsten Voranmeldung', '− ' + geld(r.vorsteuer), false]);
      } else {
        /* Ausserhalb Deutschlands stellt niemand diesen Bruttobetrag in Rechnung.
           Die Einfuhr- oder Erwerbsteuer ist als Vorsteuer neutral – sie mindert den
           Preis nicht und steht deshalb ohne Betrag da, sonst ginge die Spalte nicht auf. */
        zeilen.push(['Nettopreis ab Werk', geld(r.netto), false]);
        zeilen.push([(S.land === 'CH'
          ? 'Einfuhrsteuer ' + proz(d.mwst * 100) + ' – beim Zoll fällig, als Vorsteuer abziehbar'
          : 'Erwerb- oder Einfuhrsteuer – als Vorsteuer abziehbar'), 'nicht eingerechnet', true]);
      }

      if (!d.tief) {
        /* Ohne belegten Jahresverlauf zeigen wir nur die Gesamtwirkung. */
        $('#abHeroL').textContent = 'Über die Nutzungsdauer bleibt bei dir';
        $('#abHero').textContent = geldR(r.gesamt);
        $('#abHeroS').textContent = 'Wie sich das auf die Jahre verteilt, richtet sich nach nationalem Recht.';
        zeilen.push(['Steuerersparnis gesamt bei ' + proz(S.satz), '− ' + geld(r.erspGesamt), false]);
        $('#abMarke').textContent = 'Grobe Orientierung';
      } else if (r.istGwg) {
        $('#abHeroL').textContent = 'Nach Steuern bleibt bei dir';
        $('#abHero').textContent = geldR(r.gesamt);
        $('#abHeroS').textContent = 'Sofort abgesetzt – sofern das Gerät für sich allein nutzbar ist.';
        zeilen.push(['Sofortabzug im Kaufjahr', '− ' + geld(r.erspJahr1), false]);
        $('#abMarke').textContent = 'Unter ' + d.gwgText + ' · sofort';
      } else {
        $('#abHeroL').textContent = (r.erspVorjahr > 0)
          ? 'Bis Ende des Kaufjahrs bleibt an dir hängen'
          : 'Im Kaufjahr bleibt an dir hängen';
        $('#abHero').textContent = geldR(r.kaufjahr);
        $('#abHeroS').textContent = 'Über die ganze Nutzungsdauer: ' + geldR(r.gesamt) + '.';
        /* Die Vorjahres-Zeile steht VOR der Kaufjahr-Zeile und heißt nicht mehr
           „davon“ – sonst stand dort ein Teilbetrag, der größer war als sein Ganzes. */
        if (r.erspVorjahr > 0) {
          zeilen.push(['Schon im Vorjahr durch den IAB', '− ' + geld(r.erspVorjahr), false]);
        }
        zeilen.push(['Steuerersparnis im Kaufjahr', '− ' + geld(r.erspJahr1), false]);
        zeilen.push(['Steuerersparnis gesamt', geld(r.erspGesamt), true]);
        $('#abMarke').textContent = gewinnOffen()
          ? 'Gewinn im Vorjahr? Bitte unten wählen'
          : proz(r.abschrJahr1 / r.netto * 100) + ' der Anschaffungskosten im 1. Jahr abgeschrieben';
      }
    }

    $('#abZeilen').innerHTML = zeilen.map(function (z) {
      return '<div class="ruwi-ab-zeile' + (z[2] ? ' ruwi-ab-zeile-hell' : '') + '">' +
             '<span>' + z[0] + '</span><span class="ruwi-ab-num">' + z[1] + '</span></div>';
    }).join('');
  }

  function zeichneWege() {
    var d = LAND[S.land];
    var box = $('#abWege');
    var aktiv = (S.modus === 'betrieb') && d.tief && !(S.netto > 0 && S.netto <= d.gwg) && S.netto > 0;
    box.hidden = !aktiv;
    $('#abGewinn').hidden = !aktiv;
    if (!aktiv) {
      $('#abWegNote').textContent = '';
      return;
    }
    $$('#abGewinn [role=radio]').forEach(function (b) {
      var an = (b.dataset.gewinn === S.gewinn);
      b.setAttribute('aria-checked', String(an));
      b.tabIndex = (an || (gewinnOffen() && b.dataset.gewinn === 'klein')) ? 0 : -1;
    });

    var werte = {};
    ['linear', 'hebel', 'iab'].forEach(function (w) {
      var r = rechne(w);
      werte[w] = (r.abschrJahr1 + r.plan.vorjahr) / r.netto * 100;
    });

    /* Über 200.000 € Gewinn entfallen Sonderabschreibung und Investitionsabzugsbetrag.
       Die degressive AfA bleibt – sie hängt nicht an dieser Grenze.
       Solange die Frage offen ist, zeigen wir für beide § 7g-Wege keine Zahl. */
    var max = (gross() || gewinnOffen()) ? Math.max(werte.linear, werte.hebel, 1)
                                         : Math.max(werte.linear, werte.hebel, werte.iab, 1);

    $$('#abWege .ruwi-ab-weg').forEach(function (b) {
      var w = b.dataset.weg;
      var siebenG = (w === 'hebel' || w === 'iab');
      var aus = (gross() && w === 'iab') || (gewinnOffen() && siebenG);
      b.classList.toggle('ruwi-ab-weg-aus', aus);
      b.setAttribute('aria-disabled', String(aus));
      b.setAttribute('aria-checked', String(!aus && w === wegAktiv()));
      b.tabIndex = (!aus && w === wegAktiv()) ? 0 : -1;   /* eine Tabstopp-Station je Gruppe */

      if (w === 'hebel') {
        b.querySelector('.ruwi-ab-weg-t').textContent = gross()
          ? 'Nur degressive Abschreibung'
          : 'Degressiv plus Sonderabschreibung';
        b.querySelector('.ruwi-ab-weg-s').textContent = gross()
          ? 'Dreifach linear, gekappt bei 30 % – ohne § 7g'
          : '§ 7g Absatz 5 – höchstens 200.000 € Gewinn im Vorjahr';
      }
      if (w === 'iab') {
        b.querySelector('.ruwi-ab-weg-s').textContent = gross()
          ? 'Entfällt über 200.000 € Gewinn'
          : '§ 7g Absatz 1 – die Hälfte schon im Jahr vor dem Kauf';
      }

      var zahl = gewinnOffen() && siebenG ? '?' : (aus ? '–' : fmt(werte[w], werte[w] < 10 ? 1 : 0));
      b.querySelector('[data-pct]').textContent = zahl;
      /* Solange die Frage offen ist, zeigt die Tafel keinen Vergleich – dann darf
         auch der lineare Balken nicht auf voller Breite stehen. */
      b.querySelector('.ruwi-ab-weg-bar i').style.width =
        (aus || gewinnOffen()) ? '0%' : (werte[w] / max * 100) + '%';
    });

    $('#abWegNote').textContent = gewinnOffen()
      ? 'Beantworte die Frage darüber, dann rechnen wir die beiden § 7g-Wege für dich aus. ' +
        'Ohne Antwort zeigen wir nur den Weg, der für jeden Betrieb gilt.'
      : (gross()
        ? 'Anteil der Anschaffungskosten, der bis zum Ende des Kaufjahrs abgesetzt ist. Über der ' +
          'Gewinngrenze bleibt die degressive Abschreibung – sie hängt nicht an § 7g.'
        : 'Anteil der Anschaffungskosten, der bis zum Ende des Kaufjahrs abgesetzt ist – ' +
          'beim Investitionsabzugsbetrag einschließlich der Hälfte, die schon das Vorjahr mindert. ' +
          'Klick eine Zeile an, die Achse unten folgt.');
  }

  function zeichneAchse(r) {
    var d = LAND[S.land];
    var box = $('#abBalken');
    var leiste = $('#abJahrL');
    var hinweis = $('#abLandHinweis');

    /* Ohne belegten Jahresverlauf keine Jahresachse – lieber nichts als eine erfundene Kurve. */
    if (S.modus === 'privat' || !d.tief) {
      $('#abAchse').hidden = true;
      box.innerHTML = '';
      leiste.innerHTML = '';
      hinweis.hidden = (S.modus === 'privat') || !d.hinweis;
      hinweis.textContent = d.hinweis || '';
      return;
    }
    $('#abAchse').hidden = false;
    hinweis.hidden = true;

    var posten = [];
    if (r.erspVorjahr > 0) {
      posten.push({ label: 'Vor', vor: r.erspVorjahr, vst: 0, st: 0 });
    }
    r.ersparnisse.forEach(function (e, i) {
      posten.push({ label: String(i + 1), vor: 0, vst: (i === 0 ? r.vorsteuer : 0), st: e });
    });

    var max = Math.max.apply(null, posten.map(function (p) { return p.vor + p.vst + p.st; }));
    if (!(max > 0)) { max = 1; }

    box.innerHTML = posten.map(function (p) {
      var h = function (v) { return (v / max * 100).toFixed(2) + '%'; };
      var stapel = '';
      if (p.st > 0)  { stapel += '<span class="ruwi-ab-seg-st"  style="height:' + h(p.st) + '"></span>'; }
      if (p.vst > 0) { stapel += '<span class="ruwi-ab-seg-vst" style="height:' + h(p.vst) + '"></span>'; }
      if (p.vor > 0) { stapel += '<span class="ruwi-ab-seg-vor" style="height:' + h(p.vor) + '"></span>'; }
      var summe = p.vor + p.vst + p.st;
      return '<span class="ruwi-ab-jahr" title="' + p.label + ': ' + geld(summe) + '">' +
             '<span class="ruwi-ab-stapel">' + stapel + '</span></span>';
    }).join('');

    leiste.innerHTML = posten.map(function (p) { return '<span>' + p.label + '</span>'; }).join('');

    /* Dieselben Zahlen noch einmal als Tabelle, nur für Screenreader und Tastatur.
       Im Diagramm stecken sie sonst ausschließlich im title-Attribut. */
    $('#abAchseTabelle').innerHTML =
      '<table><caption>Was in welchem Jahr zurückkommt</caption><thead><tr>' +
      '<th>Zeitraum</th><th>Vorsteuer</th><th>Steuerersparnis</th><th>Summe</th>' +
      '</tr></thead><tbody>' +
      posten.map(function (p) {
        var name = (p.label === 'Vor') ? 'Vorjahr' : 'Jahr ' + p.label;
        return '<tr><td>' + name + '</td><td>' + geld(p.vst) + '</td><td>' +
               geld(p.st + p.vor) + '</td><td>' + geld(p.vor + p.vst + p.st) + '</td></tr>';
      }).join('') + '</tbody></table>';
    box.setAttribute('aria-label',
      'Balkendiagramm über ' + posten.length + ' Zeiträume. Die Zahlen stehen in der Tabelle darunter.');

    var text;
    if (r.istGwg) {
      text = 'Unter ' + d.gwgText + ' greift die Sofortabschreibung: der volle Betrag mindert den Gewinn ' +
             'im Kaufjahr, gleich in welchem Monat geliefert wird. Das gilt allerdings nur für Geräte, ' +
             'die für sich allein nutzbar sind – Zubehör für eine bestimmte Maschine wird mit ihr aktiviert.';
    } else {
      var kaufjahrZurueck = r.vorsteuer + r.erspJahr1;
      var spaeter = r.erspGesamt - r.erspJahr1 - r.erspVorjahr;
      var restjahre = Math.max(0, r.ersparnisse.length - 1);
      text = 'Im Kaufjahr kommen ' + geldR(kaufjahrZurueck) + ' zurück – Vorsteuer und ' +
             'Steuerersparnis zusammen. Danach noch ' + geldR(spaeter) + ' über ' + restjahre +
             ' Jahre. Die Vorsteuer hast du in Wochen zurück; die Steuerersparnis wirkt über die ' +
             'Veranlagung oder angepasste Vorauszahlungen, nicht am Kauftag.';
      if (r.erspVorjahr > 0) {
        text = 'Der erste Balken ist das Vorjahr: ' + geldR(r.erspVorjahr) + ' mindern deinen Gewinn, ' +
               'bevor das Gerät überhaupt in der Werkstatt steht. ' + text;
      }
    }
    $('#abAchseFuss').textContent = text;
  }

  function zeichneDezember() {
    var d = LAND[S.land];
    var box = $('#abDez');
    var zeigen = (S.modus === 'betrieb') && d.tief && S.netto > d.gwg;
    box.hidden = !zeigen;
    if (!zeigen) { return; }

    /* Die Karte erklärt § 7g. Solange die Gewinnfrage offen ist, rechnet sie
       trotzdem damit – als ausdrücklich beschriftetes Beispiel. Über der
       Gewinngrenze rechnet sie ohne § 7g und dreht ihre Aussage um. */
    var annahme = gross() ? 'gross' : 'klein';
    var merk = S.monat;
    S.monat = 1;  var jan = rechne('hebel', annahme);
    S.monat = 12; var dez = rechne('hebel', annahme);
    S.monat = 12; var dezLin = rechne('linear', annahme);
    S.monat = merk;

    $('#abDezJan').textContent = geldR(jan.abschrJahr1);
    $('#abDezJanS').textContent = proz(jan.abschrJahr1 / jan.netto * 100) + ' der Anschaffungskosten';
    $('#abDezDez').textContent = geldR(dez.abschrJahr1);
    $('#abDezDezS').textContent = proz(dez.abschrJahr1 / dez.netto * 100) + ' der Anschaffungskosten';

    if (gross()) {
      /* Ohne § 7g wird auch der Kaufjahresbetrag monatsgenau gekürzt – die
         Überschrift der Karte gilt dann nicht mehr. Sie umzudrehen ist ehrlicher
         und für den größeren Betrieb die wertvollere Aussage. */
      $('#abDezKicker').textContent = 'Für dich gilt der Hebel nicht';
      $('#abDezH2').textContent = 'Über der Gewinngrenze zählt der Monat voll durch';
      $('#abDezEinleitung').textContent =
        'Die Sonderabschreibung wird nicht gezwölftelt – aber über 200.000 € Gewinn im Vorjahr ' +
        'steht sie dir nicht zu. Es bleibt die degressive Abschreibung, und die kürzt jeder Monat: ' +
        'im Dezember auf ein Zwölftel.';
      $('#abDezText').innerHTML =
        'Bei ' + (S.titel || 'dem gewählten Gerät') + ' heißt das: <b>' + geldR(dez.abschrJahr1) +
        '</b> bei Lieferung im Dezember gegen ' + geldR(jan.abschrJahr1) + ' im Januar. ' +
        'Für dich ist der Januar der bessere Monat, nicht der Dezember.';
      $('#abDezSchluss').innerHTML =
        '<b>Verschieb deswegen nichts ins alte Jahr.</b> Wenn ohnehin im Frühjahr geliefert wird, ' +
        'ist das für dich der günstigere Weg.';
      return;
    }

    $('#abDezKicker').textContent = 'Der Monat, den keiner rechnet';
    $('#abDezH2').textContent = 'Die Sonderabschreibung wird nicht gezwölftelt';
    $('#abDezEinleitung').textContent =
      'Die degressive Abschreibung zählt monatsgenau: Wer im Dezember geliefert bekommt, bekommt ' +
      'ein Zwölftel davon. Die Sonderabschreibung nach § 7g nicht – sie ist ein Jahresbetrag. ' +
      'Volle 40 Prozent, auch bei Lieferung am 20. Dezember.';
    $('#abDezText').innerHTML =
      'Bei ' + (S.titel || 'dem gewählten Gerät') + ' heißt das: <b>' + geldR(dez.abschrJahr1) +
      '</b> statt ' + geldR(jan.abschrJahr1) + ' im Kaufjahr – trotz elf Monaten Unterschied. ' +
      'Rein linear wären es bei Lieferung im Dezember ' + geldR(dezLin.abschrJahr1) + '.';
    $('#abDezSchluss').innerHTML =
      '<b>Das ist kein Grund, im Dezember etwas zu kaufen, das du nicht brauchst.</b> Es ist ein ' +
      'Grund, eine ohnehin geplante Anschaffung nicht ins neue Jahr zu schieben – und rechtzeitig ' +
      'zu bestellen, damit die Lieferung noch dieses Jahr ankommt.' +
      (gewinnOffen()
        ? ' <br><br>Gerechnet für einen Betrieb mit höchstens 200.000 € Gewinn im Vorjahr. ' +
          'Beantworte die Frage oben, dann rechnen wir es für dich.'
        : '');
  }

  function zeichneStunden(r) {
    var wert = (S.modus === 'privat') ? r.brutto : r.gesamt;
    var satz = parseFloat($('#abStundensatz').value) || 0;
    if (!(satz > 0) || !(wert > 0)) { $('#abStundenText').textContent = '—'; return; }
    var stunden = wert / satz;
    /* Die Zahl steht als eigene Zeile oben, der Satz darunter – sonst bricht der
       Satz hinter der großen Zahl um und beginnt mit einem Punkt. */
    $('#abStundenText').innerHTML =
      '<b>' + fmt(stunden, stunden < 10 ? 1 : 0) + ' Werkstattstunden</b>' +
      geldR(wert) + ' über die Nutzungsdauer – so viel Zeit muss dir das Gerät sparen, ' +
      'damit es sich getragen hat.';
  }

  function zeichneZins(r) {
    var d = LAND[S.land];
    if (S.modus !== 'betrieb' || !d.tief || r.istGwg || S.satz === 0 || gewinnOffen()) {
      $('#abZins').innerHTML = '<b>Vorziehen ist kein geschenktes Geld.</b> Die degressive Abschreibung ' +
        'verschiebt die Steuerlast in die ersten Jahre. Das bringt Liquidität und Zinsvorteil – ' +
        'die Gesamtsumme bleibt gleich.';
      return;
    }
    var merk = S.weg;
    S.weg = 'linear'; var lin = rechne('linear');
    S.weg = merk;
    var vorteil = r.barwert - lin.barwert;
    $('#abZins').innerHTML =
      '<b>Vorziehen ist kein geschenktes Geld.</b> Die Gesamtersparnis ist auf beiden Wegen ' +
      geldR(r.erspGesamt) + ' – sie kommt nur früher. Bei ' + proz(ZINS * 100) + ' Kapitalkosten ist ' +
      'dieser Zeitvorteil <b>' + geldR(Math.max(0, vorteil)) + '</b> wert. Mehr ist es nicht, ' +
      'und weniger auch nicht.';
  }

  function zeichneKauf(r) {
    var box = $('#abKaufSec');
    /* Ohne Varianten-ID kein Warenkorb – das trifft den Fall „Eigener Betrag“. */
    box.hidden = !S.variante;
    if (!S.variante) { return; }

    var d = LAND[S.land];
    /* Der Preis neben einem Kaufknopf muss der Preis der Ware sein – nicht die
       Summe inklusive einer Zubehör-Hausnummer, die gar nicht mitgekauft wird. */
    var wareNetto = S.geraet * S.stueck;
    var wareBrutto = wareNetto * (1 + d.mwst);

    /* Kein „davon“: r.kaufjahr und r.gesamt rechnen die ganze Investition
       einschließlich Zubehör, wareBrutto nur die Ware. Zwei Bezugsgrößen in einem
       Satz – genau der Fehler, den die Prüfrunde im Ergebniskasten gefunden hat. */
    var bezug = (S.zubehoer > 0)
      ? 'Von der ganzen Investition über ' + geld(r.netto) + ' netto belasten dich im Kaufjahr '
      : 'Im Kaufjahr belasten dich davon ';
    $('#abKaufText').textContent = (S.modus === 'privat')
      ? S.titel + ' für ' + geld(wareBrutto) + ' brutto.'
      : S.titel + ' – ' + geld(wareBrutto) + ' brutto. ' + bezug +
        geldR(r.kaufjahr) + ', über die Nutzungsdauer bleiben ' + geldR(r.gesamt) + '.';

    var hinweise = [];
    if (S.zubehoer > 0) {
      hinweise.push('Gerechnet ist mit ' + geld(S.zubehoer) + ' Zubehör obendrauf; in den ' +
                    'Warenkorb kommt nur das Hauptgerät.');
    }
    if (S.lieferbar === false) {
      hinweise.push('Dieser Artikel ist derzeit nicht lieferbar – ruf an, wir sagen dir wann: ' +
                    '+49 7402 8414.');
    }
    $('#abKauf').disabled = (S.lieferbar === false);
    $('#abKaufHint').textContent = hinweise.join(' ');
  }

  function zeichneDruck(r) {
    var d = LAND[S.land];
    var w = wegAktiv();
    /* Der Weg muss heißen, was gerechnet wurde. Über der Gewinngrenze steht keine
       Sonderabschreibung im Blatt, das zum Steuerberater geht. */
    var wegName = {
      linear: 'Lineare Abschreibung, § 7 Abs. 1 EStG',
      hebel: gross() ? 'Degressive Abschreibung, § 7 Abs. 2 EStG (ohne § 7g)'
                     : 'Degressive AfA und Sonderabschreibung § 7g Abs. 5 EStG',
      iab: 'Investitionsabzugsbetrag § 7g Abs. 1, degressive AfA und Sonderabschreibung § 7g Abs. 5 EStG'
    };
    var mitSonder = d.tief && !r.istGwg && S.modus === 'betrieb' && !gross() && !gewinnOffen() &&
                    (w === 'hebel' || w === 'iab');
    var wegText = (S.modus === 'privat')
      ? 'Privatkauf – keine Abschreibung, kein Vorsteuerabzug'
      : (!d.tief
        ? 'Vorsteuer und Gesamtwirkung über die Nutzungsdauer. Der Jahresverlauf nach ' +
          d.name + ' ist hier nicht abgebildet.'
        : (r.istGwg ? 'Sofortabzug als geringwertiges Wirtschaftsgut, § 6 Abs. 2 EStG'
                    : (wegName[w] || '')));
    var zeilen = [];
    if (r.plan.vorjahr > 0) {
      zeilen.push(['Vorjahr', r.plan.vorjahr, r.erspVorjahr]);
    }
    r.plan.reihe.forEach(function (a, i) {
      zeilen.push(['Jahr ' + (i + 1), a, r.ersparnisse[i]]);
    });
    var summeA = r.plan.reihe.reduce(function (a, b) { return a + b; }, 0) + r.plan.vorjahr;

    var annahmen = [
      ['Gerät', S.titel || '—'],
      ['Nettopreis', geld(r.netto) + (S.zubehoer > 0 ? ' (davon ' + geld(S.zubehoer) + ' Zubehör)' : '')],
      [d.tief ? 'Bruttopreis' : 'Nettopreis ab Werk',
       d.tief ? geld(r.brutto) + ' (' + proz(d.mwst * 100) + ' Umsatzsteuer)'
              : geld(r.netto) + ' zuzüglich Einfuhr- oder Erwerbsteuer'],
      ['Land', d.name],
      ['Käufer', S.modus === 'betrieb' ? 'Betrieb, vorsteuerabzugsberechtigt' : 'Privat'],
      ['Angesetzter Steuersatz', proz(S.satz)],
      ['Monat der Lieferung', MONATE[S.monat - 1]]
    ];
    if (d.tief && S.modus === 'betrieb') {
      /* Die Zeile, die ein Steuerberater zuerst sucht. */
      annahmen.push(['Gewinn im Vorjahr', gewinnOffen()
        ? 'nicht angegeben – § 7g deshalb nicht angesetzt'
        : (gross() ? 'über 200.000 € (Angabe des Nutzers) – § 7g nicht anwendbar'
                   : 'höchstens 200.000 € (Angabe des Nutzers)')]);
    }
    if (d.tief && !r.istGwg && S.modus === 'betrieb') {
      annahmen.push(['Nutzungsdauer', d.nutzungsdauer + ' Jahre (AfA-Tabelle AV, Werkstatteinrichtung)']);
      if (w !== 'linear') {
        annahmen.push(['Degressiver Satz',
                       fmt(Math.min(d.degFaktor / d.nutzungsdauer, d.degKappe) * 100, 2) +
                       ' % (3-fach linear, gekappt bei 30 %)']);
      }
      if (mitSonder) {
        annahmen.push(['Sonderabschreibung', proz(d.sonderAfa * 100) + ' im Kaufjahr, nicht zeitanteilig']);
      }
    }
    if (r.istGwg) {
      annahmen.push(['Sofortabzug', 'geringwertiges Wirtschaftsgut, § 6 Abs. 2 EStG – setzt voraus, ' +
                     'dass das Gerät für sich allein nutzbar ist']);
    }

    /* Nur die Paragraphen drucken, die auf diese Rechnung zutreffen. Vorher stand
       unter jedem Blatt derselbe deutsche Block – auch unter Österreich und unter
       einer rein linearen Rechnung. */
    var noten = [];
    if (d.tief && !r.istGwg && S.modus === 'betrieb') {
      noten.push('Die Abschreibung im Kaufjahr ist monatsgenau ab dem Monat der Lieferung angesetzt ' +
                 '(§ 7 Abs. 1 Satz 4 EStG).');
      if (mitSonder) {
        noten.push('Die Sonderabschreibung nach § 7g Abs. 5 EStG ist ein Jahresbetrag und wird nicht ' +
                   'gekürzt. Nach Ablauf des fünfjährigen Begünstigungszeitraums ist der Restbuchwert ' +
                   'gleichmäßig auf die Restnutzungsdauer verteilt (§ 7a Abs. 9 EStG).');
      } else if (w !== 'linear') {
        noten.push('Ohne Sonderabschreibung greift § 7a Abs. 9 EStG nicht; die degressive AfA läuft ' +
                   'weiter bis zum Wechsel auf die lineare Abschreibung (§ 7 Abs. 3 EStG).');
      }
    }
    noten.push('Rundungsdifferenzen von wenigen Cent sind möglich.');

    var fuss = [];
    fuss.push('Diese Aufstellung ist eine Orientierung und ersetzt keine steuerliche Beratung.');
    if (!d.tief) {
      fuss.push('Für ' + d.name + ' bilden wir nur Vorsteuer und Gesamtwirkung ab. Nutzungsdauer, ' +
                'Sofortabzugsgrenzen und nationale Investitionsbegünstigungen richten sich nach ' +
                'dortigem Recht und stehen hier bewusst nicht.');
    } else if (mitSonder) {
      fuss.push('Sonderabschreibung und Investitionsabzugsbetrag nach § 7g EStG setzen einen Gewinn von ' +
                'höchstens 200.000 € im Vorjahr voraus, eine betriebliche Nutzung von mindestens ' +
                '90 Prozent im Kaufjahr und im Jahr danach sowie den Verbleib in einer inländischen ' +
                'Betriebsstätte. Ein Investitionsabzugsbetrag wird rückgängig gemacht und verzinst, ' +
                'wenn die Investition ausbleibt.');
      fuss.push('Die Sonderabschreibung ist hier vollständig ins Kaufjahr gelegt; sie darf auf das ' +
                'Kaufjahr und die vier folgenden Jahre verteilt werden.');
    }
    if (d.tief && !r.istGwg && S.modus === 'betrieb' && w !== 'linear') {
      fuss.push('Die degressive Abschreibung gilt für Anschaffungen vom 1. Juli 2025 bis ' +
                '31. Dezember 2027.');
    }
    fuss.push('Rechtsstand ' + STAND + '.');

    $('#abDruck').innerHTML =
      '<div class="ruwi-ab-dkopf"><span class="ruwi-ab-dlogo">RUWI</span>' +
      '<span>Abschreibungsrechnung · Stand ' + STAND + '</span></div>' +
      '<h2>' + (S.titel || 'Investitionsrechnung') + '</h2>' +
      '<p>Berechneter Weg: ' + wegText + '</p>' +
      '<h3>Annahmen</h3><div class="ruwi-ab-dgrid">' +
      annahmen.map(function (a) {
        return '<div class="ruwi-ab-dzeile"><span>' + a[0] + '</span><span>' + a[1] + '</span></div>';
      }).join('') + '</div>' +
      '<h3>Ergebnis</h3><div class="ruwi-ab-dgrid">' +
      [['Vorsteuer', geld(r.vorsteuer)],
       ['Abschreibung im Kaufjahr', geld(r.abschrJahr1)],
       ['Steuerersparnis im Kaufjahr', geld(r.erspJahr1)],
       ['Steuerersparnis gesamt', geld(r.erspGesamt)],
       ['Bis Ende des Kaufjahrs belastet', geld(r.kaufjahr)],
       ['Über die Nutzungsdauer belastet', geld(r.gesamt)]].map(function (a) {
        return '<div class="ruwi-ab-dzeile"><span>' + a[0] + '</span><span>' + a[1] + '</span></div>';
      }).join('') + '</div>' +
      (zeilen.length
        ? '<h3>Verlauf</h3><table><thead><tr><th>Zeitraum</th><th>Abschreibung</th>' +
          '<th>Steuerersparnis bei ' + proz(S.satz) + '</th></tr></thead><tbody>' +
          zeilen.map(function (z) {
            return '<tr><td>' + z[0] + '</td><td>' + geld(z[1]) + '</td><td>' + geld(z[2]) + '</td></tr>';
          }).join('') +
          '</tbody><tfoot><tr><td>Summe</td><td>' + geld(summeA) + '</td><td>' + geld(r.erspGesamt) +
          '</td></tr></tfoot></table>'
        : '') +
      '<p class="ruwi-ab-dnote">' + noten.join(' ') + '</p>' +
      '<div class="ruwi-ab-dfuss">' + fuss.join(' ') + '<br>' +
      'RUWI GmbH · Werkzeuge für Holzprofis · +49 7402 8414 · ruwi.de</div>';
  }

  /* ---------------------------------------------------------------------
     Neu zeichnen
     --------------------------------------------------------------------- */
  function alles() {
    var d = LAND[S.land];
    S.netto = leseNetto();

    $$('.ruwi-ab-lands button').forEach(function (b) {
      var an = (b.dataset.land === S.land);
      b.setAttribute('aria-checked', String(an));
      b.tabIndex = an ? 0 : -1;
    });
    $$('.ruwi-ab-seg [role=radio]').forEach(function (b) {
      b.setAttribute('aria-checked', String(b.dataset.modus === S.modus));
    });

    $('#abSatzWert').textContent = S.satz;
    $('#abSatz').value = S.satz;
    $('#abSatz').setAttribute('aria-valuetext', S.satz + ' Prozent');
    $('#abSatzHint').textContent = d.satzHint;
    $('#abSatzFeld').hidden = (S.modus === 'privat');

    $('#abMonatWert').textContent = MONATE[S.monat - 1];
    /* Der Regler muss den Wert selbst tragen, nicht nur die Beschriftung daneben –
       sonst steht der Knopf im Februar auf September und der erste Tastendruck
       springt in den Oktober. */
    $('#abMonat').value = S.monat;
    $('#abMonat').setAttribute('aria-valuetext', MONATE[S.monat - 1]);
    var monatRelevant = (S.modus === 'betrieb') && d.tief && S.netto > d.gwg;
    $('#abMonatFeld').hidden = !monatRelevant;
    $('#abMonatHint').textContent = monatRelevant
      ? 'Maßgeblich ist der Monat der Lieferung, nicht der Bestellung. Er kürzt die laufende ' +
        'Abschreibung, nicht die Sonderabschreibung.'
      : '';

    $('#abEigenWaehrung').textContent = d.waehrung + ' netto';

    /* Ohne gültigen Betrag gibt es nichts zu rechnen – sonst stünde überall NaN. */
    if (!(S.netto > 0)) {
      $('#abHeroL').textContent = 'Trag einen Betrag ein';
      $('#abHero').textContent = '—';
      $('#abHeroS').textContent = '';
      $('#abZeilen').innerHTML = '';
      $('#abMarke').textContent = '';
      $('#abWege').hidden = true;
      $('#abGewinn').hidden = true;
      $('#abAchse').hidden = true;
      $('#abDez').hidden = true;
      $('#abKaufSec').hidden = true;
      $('#abAktionen').hidden = true;
      /* Ein leeres Druckblatt ist besser als das des vorigen Geräts. */
      $('#abDruck').innerHTML = '';
      $('#abStundenText').textContent = '—';
      $('#abZins').innerHTML = '<b>Vorziehen ist kein geschenktes Geld.</b> Die degressive ' +
        'Abschreibung verschiebt die Steuerlast in die ersten Jahre. Das bringt Liquidität und ' +
        'Zinsvorteil – die Gesamtsumme bleibt gleich.';
      schreibeUrl();
      return;
    }
    $('#abAktionen').hidden = false;

    var r = rechne(wegAktiv());
    zeichneErgebnis(r);
    zeichneWege();
    zeichneAchse(r);
    zeichneDezember();
    zeichneStunden(r);
    zeichneZins(r);
    zeichneKauf(r);
    zeichneDruck(r);
    ansage(r);
    schreibeUrl();
  }

  /* Entprellte Kurzfassung für Screenreader. Ohne sie läse ein Reglerzug die
     komplette Ergebnistafel fünfzehnmal vor. */
  var ansageTimer = null;
  function ansage(r) {
    if (ansageTimer) { clearTimeout(ansageTimer); }
    ansageTimer = setTimeout(function () {
      var el = $('#abAnsage');
      if (!el) { return; }
      el.textContent = $('#abHeroL').textContent + ': ' + $('#abHero').textContent + '. ' +
                       $('#abHeroS').textContent;
    }, 450);
  }

  /* ---------------------------------------------------------------------
     Teilen und Wiederherstellen
     --------------------------------------------------------------------- */
  function url() {
    var p = ['l=' + S.land, 'w=' + (S.modus === 'privat' ? 'p' : 'g'),
             'r=' + S.satz, 'm=' + S.monat, 'v=' + S.weg];
    var sel = $('#abProd');
    if (sel.value === 'eigen') { p.push('n=' + S.geraet); }
    else { p.push('n=' + sel.value, 't=' + encodeURIComponent(S.titelBasis || S.titel)); }
    if (S.zubehoer > 0) { p.push('z=' + S.zubehoer); }
    if (S.stueck > 1) { p.push('s=' + S.stueck); }
    if (S.gewinn) { p.push('g=' + S.gewinn); }
    return location.origin + location.pathname + '?' + p.join('&');
  }
  function schreibeUrl() {
    try { history.replaceState(null, '', url()); } catch (e) { /* file:// */ }
  }
  function ausUrl() {
    var q = location.search.replace(/^\?/, '');
    if (!q) { return; }
    var m = {};
    q.split('&').forEach(function (kv) {
      var i = kv.indexOf('=');
      if (i > 0) { m[kv.slice(0, i)] = decodeURIComponent(kv.slice(i + 1).replace(/\+/g, ' ')); }
    });
    if (m.l && LAND[m.l]) { S.land = m.l; }
    if (m.w === 'p') { S.modus = 'privat'; }
    var r = parseInt(m.r, 10); if (r >= 0 && r <= 45) { S.satz = r; $('#abSatz').value = r; }
    var mo = parseInt(m.m, 10); if (mo >= 1 && mo <= 12) { S.monat = mo; $('#abMonat').value = mo; }
    if (m.v === 'linear' || m.v === 'hebel' || m.v === 'iab') { S.weg = m.v; }
    if (m.g === 'klein' || m.g === 'gross') { S.gewinn = m.g; }
    if (m.g === '1') { S.gewinn = 'gross'; }   /* alte Adressen */

    var st = parseInt(m.s, 10);
    if (st >= 1 && st <= 99) { $('#abStueck').value = st; }

    /* z = Ausstattungssumme netto, kommt vom Werkstattberater */
    var z = parseFloat(m.z);
    if (z > 0) {
      $('#abZub').value = z.toFixed(2);
      $('#abZubFeld').hidden = false;
      $('#abZubMehr').hidden = true;
    }

    /* b = Bruttobetrag aus dem alten Produktseiten-Snippet */
    var brutto = parseFloat(m.b);
    var netto = parseFloat(m.n);
    if (!isNaN(brutto) && brutto > 0 && isNaN(netto)) { netto = brutto / (1 + LAND[S.land].mwst); }

    var sel = $('#abProd');
    if (!isNaN(netto) && netto > 0) {
      var treffer = Array.prototype.filter.call(sel.options, function (o) {
        return Math.abs(parseFloat(o.value) - netto) < 0.005;
      })[0];
      if (treffer) {
        sel.value = treffer.value;
      } else {
        sel.value = 'eigen';
        $('#abEigen').value = netto.toFixed(2);
        $('#abEigenFeld').hidden = false;
      }
    }
    if (m.t) { S.titelUrl = m.t; S.titel = m.t; }
  }

  /* ---------------------------------------------------------------------
     Ereignisse
     --------------------------------------------------------------------- */
  function spur(name, daten) {
    try {
      if (window.plausible) { window.plausible(name, { props: daten }); }
      if (window.dataLayer) { window.dataLayer.push(Object.assign({ event: name }, daten || {})); }
    } catch (e) { /* Tracking darf nie den Rechner anhalten */ }
  }

  $('.ruwi-ab-lands').addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) { return; }
    S.land = b.dataset.land; alles(); spur('Abschreibung: Land', { land: S.land });
  });
  $('#abProd').addEventListener('change', function () {
    $('#abEigenFeld').hidden = (this.value !== 'eigen');
    /* Der Nutzer hat hier ausdrücklich ein anderes Gerät benannt – der Titel aus
       der Adresse hat sich damit erledigt. Sonst trüge das Druckblatt den Namen
       des Geräts, von dem er gekommen ist. */
    S.titelUrl = '';
    alles(); spur('Abschreibung: Werkzeug', { werkzeug: S.titel });
  });
  $('#abEigen').addEventListener('input', alles);
  $('#abStueck').addEventListener('input', alles);
  $('#abZub').addEventListener('input', alles);
  $('#abZubMehr').addEventListener('click', function () {
    $('#abZubFeld').hidden = false;
    this.hidden = true;
    $('#abZub').focus();
    alles();
  });
  $('#abGewinn').addEventListener('click', function (e) {
    var b = e.target.closest('[role=radio]'); if (!b) { return; }
    S.gewinn = b.dataset.gewinn;
    if (gross() && S.weg === 'iab') { S.weg = 'hebel'; }
    alles();
    spur('Abschreibung: Gewinngrenze', { ueber: S.gewinn });
  });
  $$('.ruwi-ab-seg [role=radio]').forEach(function (b) {
    b.addEventListener('click', function () { S.modus = b.dataset.modus; alles(); });
  });
  $('#abSatz').addEventListener('input', function () { S.satz = parseInt(this.value, 10); alles(); });
  $('#abMonat').addEventListener('input', function () { S.monat = parseInt(this.value, 10); alles(); });
  $('#abStundensatz').addEventListener('input', function () { alles(); });
  $('#abWege').addEventListener('click', function (e) {
    var b = e.target.closest('.ruwi-ab-weg'); if (!b) { return; }
    if (b.getAttribute('aria-disabled') === 'true') { return; }
    S.weg = b.dataset.weg; alles(); spur('Abschreibung: Weg', { weg: S.weg });
  });
  /* Ein Helfer für alle drei Radiogruppen: Pfeiltasten wechseln, Pos1 und Ende
     springen an die Enden, danach wandert der Fokus mit. Gesperrte Einträge
     werden übersprungen – vorher lief der Sprung auf einen gesperrten Weg und
     danach war gar nichts mehr ausgewählt. */
  function radioTasten(e, werte, lies, setze, fokusWahl) {
    var taste = e.key;
    var vor = (taste === 'ArrowRight' || taste === 'ArrowDown') ? 1
            : (taste === 'ArrowLeft' || taste === 'ArrowUp') ? -1 : 0;
    if (!vor && taste !== 'Home' && taste !== 'End') { return; }
    if (!werte.length) { return; }

    var neu;
    if (taste === 'Home') { neu = werte[0]; }
    else if (taste === 'End') { neu = werte[werte.length - 1]; }
    else {
      var i = werte.indexOf(lies());
      if (i < 0) { i = 0; vor = 0; }
      neu = werte[(i + vor + werte.length) % werte.length];
    }
    e.preventDefault();
    setze(neu);
    alles();
    var ziel = fokusWahl();
    if (ziel) { ziel.focus(); }
  }

  $('#abWege').addEventListener('keydown', function (e) {
    radioTasten(e, wegeOffen(),
      function () { return wegAktiv(); },
      function (w) { S.weg = w; },
      function () { return $('#abWege .ruwi-ab-weg[aria-checked="true"]'); });
  });
  $('.ruwi-ab-lands').addEventListener('keydown', function (e) {
    radioTasten(e, ['DE', 'AT', 'CH', 'NL'],
      function () { return S.land; },
      function (l) { S.land = l; },
      function () { return $('.ruwi-ab-lands [aria-checked="true"]'); });
  });
  $('#abGewinn').addEventListener('keydown', function (e) {
    radioTasten(e, ['klein', 'gross'],
      function () { return S.gewinn || 'klein'; },
      function (g) { S.gewinn = g; if (gross() && S.weg === 'iab') { S.weg = 'hebel'; } },
      function () { return $('#abGewinn [aria-checked="true"]'); });
  });

  $('#abAktionen').addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) { return; }
    var akt = b.dataset.akt;
    var u = url();
    var text = 'Meine Abschreibungs-Rechnung aus dem RUWI Rechner: ' + u;
    if (akt === 'link') {
      var fertig = function () {
        var alt = b.textContent; b.textContent = 'Link kopiert';
        setTimeout(function () { b.textContent = alt; }, 2200);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(u).then(fertig, function () { window.prompt('Link kopieren:', u); });
      } else { window.prompt('Link kopieren:', u); }
    }
    if (akt === 'wa') { window.open('https://wa.me/?text=' + encodeURIComponent(text), '_blank', 'noopener'); }
    if (akt === 'mail') {
      location.href = 'mailto:?subject=' + encodeURIComponent('Meine Abschreibungs-Rechnung') +
                      '&body=' + encodeURIComponent(text);
    }
    if (akt === 'druck') { druckeBlatt(); }
    spur('Abschreibung: ' + akt);
  });

  /* Druckt nur das Blatt, nicht die ganze Shopify-Seite: eine Kopie wird als
     direktes Kind des body eingehängt, die Druck-CSS blendet alles andere aus. */
  function druckeBlatt() {
    var alt = document.querySelector('body > .ruwi-ab-druckblatt');
    if (alt) { alt.parentNode.removeChild(alt); }

    var blatt = document.createElement('div');
    blatt.className = 'ruwi-ab-druckblatt';
    blatt.innerHTML = $('#abDruck').innerHTML;
    document.body.appendChild(blatt);
    document.documentElement.classList.add('ruwi-ab-druckt');

    var aufraeumen = function () {
      document.documentElement.classList.remove('ruwi-ab-druckt');
      if (blatt.parentNode) { blatt.parentNode.removeChild(blatt); }
      window.removeEventListener('afterprint', aufraeumen);
    };
    window.addEventListener('afterprint', aufraeumen);

    window.print();
    /* Safari feuert afterprint nicht zuverlässig – Netz darunter spannen. */
    setTimeout(aufraeumen, 1500);
  }

  /* Warenkorb. Im Shop über /cart/add.js, im Prototyp nur als Ansage. */
  /* Nicht am Hostnamen festmachen: Der Theme-Editor läuft auf .myshopify.com,
     und genau dort soll das Paket vor dem Livegang geprüft werden. Die Section
     setzt `root`, die lokale Vorschau nicht. */
  var ROOT = CFG0.root || '/';
  if (ROOT.slice(-1) !== '/') { ROOT += '/'; }   /* sonst wird aus /en das Ziel /encart */
  var IM_SHOP = !!CFG0.root;
  $('#abKauf').addEventListener('click', function () {
    if (!S.variante) { return; }
    var b = this;
    spur('Abschreibung: Warenkorb', { werkzeug: S.titel });
    if (!IM_SHOP) {
      $('#abKaufHint').textContent =
        'Prototyp: hier ginge „' + S.titel + '“ (Variante ' + S.variante + ') in den Warenkorb.';
      return;
    }
    b.disabled = true;
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(S.variante), quantity: S.stueck }] })
    }).then(function (res) {
      if (!res.ok) { throw new Error('cart'); }
      location.href = ROOT + 'cart';
    }).catch(function () {
      b.disabled = false;
      $('#abKaufHint').textContent = 'Hat nicht geklappt. Ruf uns an: +49 7402 8414.';
    });
  });

  /* ---------------------------------------------------------------------
     Start
     --------------------------------------------------------------------- */
  if (CFG0.stundensatz) { $('#abStundensatz').value = CFG0.stundensatz; }

  if (SAISON) {
    /* Ab Oktober steht der Dezember-Hebel über dem Rechner, nicht darunter.
       Den Kaufmonat schreiben wir dabei NICHT um: Wer im November kauft, soll
       November rechnen und nicht ungefragt in den Dezember gestellt werden.
       Die Gegenüberstellung in der Karte macht den Punkt von allein. */
    var karte = $('#abDez');
    var rechner = root.querySelector('.ruwi-ab-rechner');
    if (karte && rechner && rechner.parentNode) { rechner.parentNode.insertBefore(karte, rechner); }
    $('#abDezSaison').hidden = false;
  }

  ladeProdukte(function () {
    baueProdukte();
    ausUrl();
    alles();
  });

})();
